import TextFormat from '../../components/TextFormat';
import { DataState } from '../../context/DataProvider';

const StepChatsCard = ({ chat }) => {
  const { userInfo } = DataState();
  const { role, content } = chat;
  const textContent = content;

  if (!textContent || !textContent.trim()) {
    return null;
  }

  return role === 'bot' ? (
    <pre className="overflow-x-auto whitespace-pre-wrap break-words rounded-md p-4 text-gray-100">
      <TextFormat response={textContent} />
    </pre>
  ) : role === 'tool' ? null : (
    <div className="flex items-start gap-1">
      <div className="min-h-10 min-w-10 pt-3">
        {role === 'user' ? (
          <img
            src={userInfo ? userInfo.picture : '/assets/nirmal.png'}
            alt="User"
            className="h-7 w-7 rounded-full object-cover"
          />
        ) : (
          <img
            src="/assets/logo.png"
            alt="Bot"
            className="h-7 w-7 rounded-full bg-black object-contain p-1"
          />
        )}
      </div>
      <p
        className={`text-sm ${
          role === 'user' ? 'text-zinc-200' : 'text-zinc-300'
        }`}
      >
        <TextFormat response={textContent} />
      </p>
    </div>
  );
};

export default StepChatsCard;
